import { BASE_URL } from "../common/constants";
import axios from "axios";
import { withTokenCheck } from "./userAxiosServices"
import { LearningPathType } from "../common/learning-path";
import { CardText } from "../common/card-model";
import { CardPictureVote } from '../common/card-model';


///CATEGORIES SERVICES

const getMyTeacherLearningPath = async (
	userId: string,
	currentPage: number,
	sortBy: 'alphabet' | 'date' = 'date', // Default to sorting by date
	sortOrder: 'asc' | 'desc' = 'desc'   // Default to descending order
) => {
	const response = axios.get(BASE_URL + `learning-paths/list-teachers/`, {
		params: {
			user_id: userId,
			page: currentPage,
			sort_by: sortBy,
			sort_order: sortOrder,
		},
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}

export const getMyTeacherLearningPathService = withTokenCheck(getMyTeacherLearningPath)

const getMyStudentLearningPath = async (
	userId: string,
	currentPage: number,
	sortBy: 'alphabet' | 'date' = 'date', // Default to sorting by date
	sortOrder: 'asc' | 'desc' = 'desc'   // Default to descending order
) => {
	const response = axios.get(BASE_URL + `learning-paths/list-students/`, {
		params: {
			user_id: userId,
			page: currentPage,
			sort_by: sortBy,
			sort_order: sortOrder,
		},
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}

export const getMyStudentLearningPathService = withTokenCheck(getMyStudentLearningPath)


const deleteLearningPath = async (learningPathId: string) => {
	const response = await axios.delete(BASE_URL + `learning-paths/details-teachers/${learningPathId}/`, {
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
			"Content-Type": "application/json"
		}
	});
	return response;
}

export const deleteLearningPathService = withTokenCheck(deleteLearningPath)

const learningPathDetails = async (learningPathId: string) => {
	const response = await axios.get(BASE_URL + `learning-paths/details-teachers/${learningPathId}/`, {
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
			"Content-Type": "application/json"
		}
	});
	return response;
}
export const learningPathDetailsService = withTokenCheck(learningPathDetails)

const teacherCreateLearningPath = async (learningPaths: LearningPathType[]) => {
	const body = learningPaths.map((lp) => ({
		start_at: lp.startAt,
		end_at: lp.endAt,
		start_test_at: lp.startTestAt,
		end_test_at: lp.endTestAt,
		created_by_user: lp.createBy,
		assigned_user: lp.assignTo,
		category: lp.category,
		category_tags: lp.categoryTags,
		daily_cards_flip_target: lp.dailyCardsFlip,
		daily_cards_learn_target: lp.dailyCardsLearn,
		flip_cards_volume: lp.flipCardVolume,
		learned_card_volume_verbal: lp.learnedCardVerbalAfterVolume,
		learned_card_volume_typing: lp.learnedCardTypingAfterVolume,
		learning_type_verbal: lp.learningTypeVerbal,
		learning_type_typing: lp.learningTypeTyping,
		completed_verbal: lp.completedVerbal,
		completed_typing: lp.completedTyping
	}));

	const response = await axios.post(BASE_URL + `learning-paths/list-teachers/`, body, {
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
			"Content-Type": "application/json"
		}
	});
	return response;
}
export const teacherCreateLearningPathService = withTokenCheck(teacherCreateLearningPath)

const getAllCardsTextLearningPath = async (learningPathId: string) => {
	const response = await axios.get(BASE_URL + `learning-paths/card-text-students/`, {
		params: { learning_path_id: learningPathId },
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
			"Content-Type": "application/json"
		}
	});
	return response;
}
export const getAllCardsTextLearningPathService = withTokenCheck(getAllCardsTextLearningPath)

const guestCardText = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  guessesScore
}: Pick<CardText, "id" | "categoryId" | "sideOne" | "sideTwo" | "guessesScore">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    guesses_score: guessesScore,
  }
  const response = axios.put(BASE_URL + `learning-paths/card-text-students/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      }
    });
  return response;
}

export const guestCardTextService = withTokenCheck(guestCardText)

const incorrectGuestCardText = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  incorrectGuessesScore
}: Pick<CardText, "id" | "categoryId" | "sideOne" | "sideTwo" | "incorrectGuessesScore">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    incorrect_guesses_score: incorrectGuessesScore,
  }
  const response = axios.put(BASE_URL + `learning-paths/card-text-students/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      }
    });
  return response;
}

export const incorrectGuestCardTextService = withTokenCheck(incorrectGuestCardText)

const guestTypingCardText = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  guessesScoreTyping
}: Pick<CardText, "id" | "categoryId" | "sideOne" | "sideTwo" | "guessesScoreTyping">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    guesses_score_typing: guessesScoreTyping,
  }
  const response = axios.put(BASE_URL + `learning-paths/card-text-students/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      }
    });
  return response;
}

export const guestTypingCardTextService = withTokenCheck(guestTypingCardText)

const incorrectGuestTypingCardText = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  incorrectGuessesScoreTyping
}: Pick<CardText, "id" | "categoryId" | "sideOne" | "sideTwo" | "incorrectGuessesScoreTyping">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    incorrect_guesses_score_typing: incorrectGuessesScoreTyping,
  }
  const response = axios.put(BASE_URL + `learning-paths/card-text-students/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      }
    });
  return response;
}

export const incorrectGuestTypingCardTextService = withTokenCheck(incorrectGuestTypingCardText)


const getAllCardsPictureLearningPath = async (learningPathId: string) => {
	const response = await axios.get(BASE_URL + `learning-paths/card-picture-students/`, {
		params: { learning_path_id: learningPathId },
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
			"Content-Type": "application/json"
		}
	});
	return response;
}
export const getAllCardsPictureLearningPathService = withTokenCheck(getAllCardsPictureLearningPath)


const guestCardPictures = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  guessesScore
}: Pick<CardPictureVote, "id" | "categoryId" | "sideOne" | "sideTwo" | "guessesScore">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    guesses_score: guessesScore,
  }
  const response = axios.put(BASE_URL + `learning-paths/card-picture-students/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      'content-Type': 'multipart/form-data'
    }
  });
  return response;
}

export const guestCardPictureService = withTokenCheck(guestCardPictures)

const incorrectGuestCardPicture = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  incorrectGuessesScore
}: Pick<CardPictureVote, "id" | "categoryId" | "sideOne" | "sideTwo" | "incorrectGuessesScore">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    incorrect_guesses_score: incorrectGuessesScore,
  }
  const response = axios.put(BASE_URL + `learning-paths/card-picture-students/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      'content-Type': 'multipart/form-data'
    }
  });
  return response;
}

export const incorrectGuestCardPictureService = withTokenCheck(incorrectGuestCardPicture)

const guestTypingCardPicture = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  guessesScoreTyping
}: Pick<CardPictureVote, "id" | "categoryId" | "sideOne" | "sideTwo" | "guessesScoreTyping">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    guesses_score_typing: guessesScoreTyping,
  }
  const response = axios.put(BASE_URL + `learning-paths/card-picture-students/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      'content-Type': 'multipart/form-data'
    }
  });
  return response;
}

export const guestTypingCardPictureService = withTokenCheck(guestTypingCardPicture)

const incorrectGuestTypingCardPicture = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  incorrectGuessesScoreTyping
}: Pick<CardPictureVote, "id" | "categoryId" | "sideOne" | "sideTwo" | "incorrectGuessesScoreTyping">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    incorrect_guesses_score_typing: incorrectGuessesScoreTyping,
  }
  const response = axios.put(BASE_URL + `learning-paths/card-picture-students/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      'content-Type': 'multipart/form-data'
    }
  });
  return response;
}

export const incorrectGuestTypingCardPictureService = withTokenCheck(incorrectGuestTypingCardPicture)


const learningPathProgress = async (
  learningPathId: string,
) => {
	const response = await axios.get(BASE_URL + `learning-paths/learning-path-progress/`, {
    params: { 
      learning_path_id: learningPathId,
    },
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
			"Content-Type": "application/json"
		}
	});
	return response;
}
export const learningPathProgressService = withTokenCheck(learningPathProgress)

